/**
 * Route helper utilities for Languages.
 *
 * Languages are a single global resource managed under /admin/jezyki.
 */
export function createLanguageRouteHelper(_siteContext, routes) {
  return {
    index: () => routes.admin_languages(),
    edit: (id) => routes.edit_admin_language(id),
    update: (id) => routes.admin_language(id),
    destroy: (id) => routes.admin_language(id),
    reorder: () => routes.reorder_admin_languages(),
  };
}
